<!-- 我的订单 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">我的服务订单</div>
      </el-col>
    </el-row>
    <el-row class="order-area" v-if="OrderList">
      <el-tabs @tab-click="tabBtn" type="border-card" v-model="tabName">
        <el-tab-pane label="待付款" name="0">
          <ul>
            <li :key="index" v-for="(itemOrder,index) in OrderList.data">
              <div>
                <span
                  :class="itemOrder.status == 0 ? 'order-state-tip order-state-normal' : 'order-state-end order-state-normal'">{{itemOrder.status == 0 ? "对方正在付款，请等待" : "对方已取消申请"}}</span>
                <span class="order-content colorBule">预定服务：({{itemOrder.serves.pushTypeStr}}){{itemOrder.serves.title}} 「{{itemOrder.serves.pushPrice}}元/{{itemOrder.serves.servePriceName}}」</span>
              </div>
              <table class="order-list">
                <tr class="order-title">
                  <td>买家</td>
                  <td>昵称</td>
                  <td width="40%">服务日期</td>
                  <td>订单价格</td>
                  <td>人数</td>
                </tr>
                <tr class="order-list-infor">
                  <td  @click="nameTo(itemOrder.serves.user.uid)">
                    <img style="width: 50px;height: 50px;border-radius: 50%" :src="itemOrder.serves.user.headImg" alt="">
                  </td>
                  <td @click="nameTo(itemOrder.serves.user.uid)">{{itemOrder.serves.user.name}}</td>
                  <td>{{itemOrder.orderStart | time}}至{{itemOrder.orderEnd  | time}}</td>
                  <td style="color: #f42626;">&yen;{{itemOrder.orderPrice}}</td>
                  <td>{{itemOrder.serveNum}}</td>
                </tr>
              </table>
              <div class="order-bottom">
                <div>
                  <a @click="$router.push('/orderAwait?orderNum=' + itemOrder.orderNum)">查看订单详情</a>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="待确认" name="1">
          <ul>
            <li :key="index" v-for="(itemOrder,index) in OrderList.data">
              <div>
                <span
                  :class="itemOrder.status == 2 ? 'order-state-tip order-state-normal' : 'order-state-end order-state-normal'">{{itemOrder.status == 2 ? "待确认" : "已拒绝服务"}}</span>
                <span class="order-content colorBule">预定服务：({{itemOrder.serves.pushTypeStr}}){{itemOrder.serves.title}} 「{{itemOrder.serves.pushPrice}}元/{{itemOrder.serves.servePriceName}}」</span>
              </div>
              <table class="order-list">
                <tr class="order-title">
                  <td>买家</td>
                  <td>昵称</td>
                  <td width="40%">服务日期</td>
                  <td>订单价格</td>
                  <td>人数</td>
                </tr>
                <tr class="order-list-infor">
                  <td  @click="nameTo(itemOrder.serves.user.uid)">
                    <img style="width: 50px;height: 50px;border-radius: 50%" :src="itemOrder.serves.user.headImg" alt="">
                  </td>
                  <td @click="nameTo(itemOrder.serves.user.uid)">{{itemOrder.serves.user.name}}</td>
                  <td>{{itemOrder.orderStart | time}}至{{itemOrder.orderEnd | time}}</td>
                  <td style="color: #f42626;">&yen;{{itemOrder.orderPrice}}</td>
                  <td>{{itemOrder.serveNum}}</td>
                </tr>
              </table>
              <div class="order-bottom">
                <div>
                  <a @click="$router.push('/orderAwait?orderNum=' + itemOrder.orderNum)">查看订单详情</a>
                </div>
              </div>
              <div class="order_add">
                <span>确认接单</span>
                <span>拒绝</span>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="进行中" name="2">
          <ul>
            <li :key="index" v-for="(itemOrder,index) in OrderList.data">
              <div>
                <span
                  :class="itemOrder.status == 4 ? 'order-state-tip order-state-normal' : 'order-state-end order-state-normal'">{{itemOrder.status == 4 ? "服务正在进行中" : ""}}</span>
                <span class="order-content colorBule">预定服务：({{itemOrder.serves.pushTypeStr}}){{itemOrder.serves.title}} 「{{itemOrder.serves.pushPrice}}元/{{itemOrder.serves.servePriceName}}」</span>
              </div>
              <table class="order-list">
                <tr class="order-title">
                  <td>买家</td>
                  <td>昵称</td>
                  <td width="40%">服务日期</td>
                  <td>订单价格</td>
                  <td>人数</td>
                </tr>
                <tr class="order-list-infor">
                  <td  @click="nameTo(itemOrder.serves.user.uid)">
                    <img style="width: 50px;height: 50px;border-radius: 50%" :src="itemOrder.serves.user.headImg" alt="">
                  </td>
                  <td @click="nameTo(itemOrder.serves.user.uid)">{{itemOrder.serves.user.name}}</td>
                  <td>{{itemOrder.orderStart | time}}至{{itemOrder.orderEnd  | time}}</td>
                  <td style="color: #f42626;">&yen;{{itemOrder.orderPrice}}</td>
                  <td>{{itemOrder.serveNum}}</td>
                </tr>
              </table>
              <div class="order-bottom">
                <div>
                  <a @click="$router.push('/orderAwait?orderNum=' + itemOrder.orderNum)">查看订单详情</a>
                </div>
              </div>
              <div class="order_add">
                服务如已完成，请联系客户进行确认；（7天客户无响应，订单自动完成）
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="已结束" name="3">
          <ul>
            <li :key="index" v-for="(itemOrder,index) in OrderList.data">
              <div>
                <span
                  :class="itemOrder.status == 5 ? 'order-state-tip order-state-normal' : 'order-state-end order-state-normal'">{{itemOrder.status == 5 ? "已完成，等待对方评价" : "已结束"}}</span>
                <span class="order-content colorBule">预定服务：({{itemOrder.serves.pushTypeStr}}){{itemOrder.serves.title}} 「{{itemOrder.serves.pushPrice}}元/{{itemOrder.serves.servePriceName}}」</span>
              </div>
              <table class="order-list">
                <tr class="order-title">
                  <td>买家</td>
                  <td>昵称</td>
                  <td width="40%">服务日期</td>
                  <td>订单价格</td>
                  <td>人数</td>
                </tr>
                <tr class="order-list-infor">
                  <td  @click="nameTo(itemOrder.serves.user.uid)">
                    <img style="width: 50px;height: 50px;border-radius: 50%" :src="itemOrder.serves.user.headImg" alt="">
                  </td>
                  <td @click="nameTo(itemOrder.serves.user.uid)">{{itemOrder.serves.user.name}}</td>
                  <td>{{itemOrder.orderStart | time}}至{{itemOrder.orderEnd  | time}}</td>
                  <td style="color: #f42626;">&yen;{{itemOrder.orderPrice}}</td>
                  <td>{{itemOrder.serveNum}}</td>
                </tr>
              </table>
              <div class="order-bottom">
                <div>
                  <a @click="$router.push('/orderAwait?orderNum=' + itemOrder.orderNum)">查看订单详情</a>
                </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <div v-if="OrderList &&　OrderList.data.length == 0">
          <empty :acceptEmptyData="acceptEmptyData"></empty>
        </div>
      </el-tabs>
      <!--分页-->
      <p style="text-align: right!important;" v-if="OrderList &&　OrderList.data.length != 0">
        <el-pagination
          :current-page="page"
          :page-size="30"
          :page-sizes="[30, 50, 80, 100]"
          :total="totalData"
          @current-change="pageChange"
          @size-change="handleSizeChange"
          background
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </p>
    </el-row>
  </div>
</template>

<!--JS-->
<script>
  import { selectServeOrderListByPush } from "api/apis";
  import empty from "../../components/common/empty";

  export default {
    components: {
      empty
    },
    data() {
      return {
        acceptEmptyData: {
          from: "services",
          msg: "您暂时还没有客户下订单～"
        },
        OrderList: "",
        tabName: "0",
        page: 1,
        pageSize: 30,
        tabIndex: "",
        totalData:0
      };
    },
    methods: {
      nameTo(uid){
        this.$router.push('/homePage?nameCode=' + uid)
      },
      handleSizeChange(val) {
        this.pageSize = val;
        // 获取服务服务列表
        this.getList(this.tabIndex);
        console.log(`每页 ${val} 条`);
      },
      pageChange(val) {
        this.page = val;
        // 获取服务服务列表
        this.getList(this.tabIndex);
        console.log(this.page, val, "翻页");
      },
      tabBtn(tab, event) {
        // console.log(tab, event);
        let vm = this;
        vm.tabIndex = tab.index;
        vm.OrderList = "";
        // 获取订单的列表
        vm.getList(tab.index);
      },
      getList(index) {
        let vm = this;
        // 获取订单的列表
        selectServeOrderListByPush({
          map: { uid: Number(localStorage.getItem("pbw_user_pc_uid")), status: Number(index) },
          nowPage: vm.page,
          nowPageDataNum: vm.pageSize
        }).then((res) => {
          vm.OrderList = res.data;
          vm.totalData = res.data.totalDataNum
        });
      }
    },
    mounted() {
      let vm = this;
      // 获取订单的列表
      vm.getList(0);

    },
    filters: {
      time: function(value) {
        var time = new Date(value * 1000);
        function add0(m) {
          return m < 10 ? '0' + m : m
        }
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        var timeResult =  add0(m) + '月' + add0(d) + '日';
        if (timeResult == '1970-01-01' || timeResult == '1970-01-02') {
          return '--'
        } else {
          return timeResult
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';

  .order_add {
    padding: 10px;
    text-align: right;
    span {
      width: 124px;
      height: 30px;
      color: #fff;
      line-height: 30px;
      border-radius: 50px;
      text-align: center;
      display: inline-block;
      background: #f60;
      cursor: pointer;
    }
  }

  /* 基本资料 */
  .avatar {
    height: 120px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }

  .bar_blog .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }

  .bar_blog .title1 {
    font-size: 18px;
    color: #333;
  }

  .bar_blog .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }

  .bar_blog .title2, .bar_blog .title2 em {
    text-align: right;
    font-size: 14px;
    color: #959595;
    line-height: 27px;
  }

  .bar_blog .repeatable {
    padding-bottom: 20px;
  }

  .bar_blog .repeatable .name {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }

  .bar_blog .repeatable .in input {
    color: #F16202
  }

  .el-border {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    line-height: 100px;
    border: 1px solid #ddd;
    text-align: center;
  }

  .bar_blog .repeatable .sex {
    line-height: 40px;
    padding-left: 10px;
  }

  .name_money {
    padding: 20px 80px;
    border: 1px solid #d5d5d5;

    span {
      color: #f60;
    }
  }


  /*我的订单*/
  .order-area {
    li {
      padding: 10px 30px;
      border-radius: 5px;
      margin: 0 5px 40px 0;
      box-shadow: 2px 4px 4px 4px rgba(197, 197, 197, 0.3);
      border: 1px solid #ddd;
    }

    .order-state-normal {
      min-width: 90px;
      padding: 0 10px;
      height: 30px;
      color: #f60;
      border: 1px solid #f60;
      line-height: 30px;
      text-align: center;
      display: inline-block;;
    }

    .order-state-tip {
      /*background: #f60;*/
    }

    .order-state-end {
      background: #ededed;
    }

    .order-content {
      padding-left: 20px;
      font-size: 17px;
      font-weight: bold;
      color: #f60;
    }

    .order-list {
      margin-top: 20px;
      background: #f7f8fc;
      padding: 20px;
      width: 100%;
      text-align: center;
      border-radius: 5px;
    }

    .order-title {
      color: #999;
      font-size: 14px;

      td {
        padding: 10px 4px;
      }
    }

    .order-list-infor {
      color: #333;
      font-size: 16px;

      td {
        padding: 4px 4px 20px;
        img{
          cursor: pointer;
        }
      }
    }

    .order-bottom {
      color: #26b3f4;
      font-size: 14px;
      background: #f7f8fc;
      padding: 0px 20px;
      div {
        padding: 10px 0px;
        border-top: 1px solid #d5d5d5;
        a{
          cursor: pointer;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/accompaniedorders.vue